<template>
  <div class="div1">
    <!-- <div v-if="!openFullscreen && !openUpdateDialog && !openSearchDialog"> -->
    <mu-appbar style="width: 100%;height:40px;" color="green"
               v-show=" !openSearchDialog">
      <mu-button icon slot="left" @click="toHome" style="font-size: 12px;width:40px;margin: 0;">
        <router-link target="_blank" :to="{path:'http://123jc.com'}"></router-link>
        <mu-icon value="home"></mu-icon>
      </mu-button>
      <span style="font-size: 16px;">金槌网上拍卖平台</span>

      <mu-button flat slot="right" small @click="search_click" style="font-size: 12px;width:40px;margin: 0;">
        <mu-icon value="search"></mu-icon>
      </mu-button>

    </mu-appbar>

    <mu-paper v-show="  !openSearchDialog" :z-depth="3" style="width: 100%;min-height:40px;margin: 0;padding: 10px;background-color: rgba(222, 222, 222, .5)">
      <span slot="right" style="font-size: 10px;"><span style="font-size: 9px;">当前 / 总数 ：</span>
        <span style="width: 10px;color: green;font-size: 12px;"
              slot="right">{{search_total_count}} / {{total_count}}</span>
        &nbsp;
        <template v-if="searchMap.auctions_name != ''">
            <mu-chip class="demo-chip" color="blue200" delete @delete="serach_key_delete('auctions_name')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28" ><span
                style="font-size: 9px;">会名</span></mu-avatar> <span
              style="font-size: 10px;">{{searchMap.auctions_name}}</span>
            </mu-chip>
        </template>

         <template v-if="searchMap.auctionCompanyName != ''">
            <mu-chip class="demo-chip" color="blue200" delete @delete="serach_key_delete('auctionCompanyName')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span
                style="font-size: 9px;">单位</span></mu-avatar> <span style="font-size: 10px;">{{searchMap.auctionCompanyName}}</span>
            </mu-chip>
        </template>

         <template v-if="searchMap.auctions_starttime_start != '' || searchMap.auctions_starttime_end != ''">
            <mu-chip class="demo-chip" color="blue200" delete @delete="serach_key_delete('auctions_starttime')" style="height:22px; vertical-align:middle;">
              <mu-avatar text-color="blue300" color="indigo900" :size="28"><span
                style="font-size: 9px;">时间</span></mu-avatar>
              <span style="font-size: 10px;">
                <template v-if="searchMap.auctions_starttime_start != ''">{{search_auctions_starttime_start_computed}}</template>
                to
                <template v-if="searchMap.auctions_starttime_end != ''">{{search_auctions_starttime_end_computed}}</template>
              </span>
            </mu-chip>
        </template>
      </span>
    </mu-paper>


    <mu-load-more ref="lm" @refresh="refresh" :refreshing="refreshing" :loading="loading" @load="load" style="width: 100%;" v-show=" !openSearchDialog" class="demo-loadmore-content">
        <mu-list style="width:100%;padding:0;margin:0;border: 0px solid #000;background-color: rgba(222, 222, 222, .5)">
          <template v-for="(item,index) in in_list">
            <template v-if="index == 0">
              <mu-row style="border: 0px solid #f00;">
                <mu-col span="12" style="padding: 4px;text-align: center">
                  <span style="font-size: 14px;font-weight:bold; color: rgba(125,150,125,.8)" >{{item.auctions_starttime_s}}</span>
                </mu-col>
              </mu-row>
            </template>
            <template v-if="index != 0 && item.auctions_starttime_s != in_list[index - 1].auctions_starttime_s">
              <mu-row style="border: 0px solid #f00;">
                <mu-col span="12" style="padding: 4px;text-align: center">
                  <span style="font-size: 14px;font-weight:bold; color: rgba(125,150,125,.8)" >{{item.auctions_starttime_s}}</span>
                </mu-col>
              </mu-row>
            </template>

            <mu-paper class="demo-paper" :z-depth="0" style="border: 0px solid #0f0; width:100%;padding: 0;margin:0;">

              <mu-expansion-panel :z-depth="0" style="width:100%;border: 0px solid #000;margin:0 auto 6px;">
                <div slot="header" style="border: 0px solid #000;width:95%;padding: 5px 0;" v-bind:class="[item.auctions_isover ? 'auctions_isover' : '' , item.auctions_starttime_s === STORE.cuur_year_month_date ? 'auctions_today':'']">
                  <mu-row style="border: 0px solid #f00;">
                    <mu-col span="12">
                      <span style="font-size : 16px;font-weight: bolder;">{{item.auctions_name}}     {{item.auctions_isover ? '已结束' : '' }}</span>
                    </mu-col>
                    <mu-col span="12">
                      <span class="s_key">拍卖师: </span><span class="s1">{{item.auctions_man}}</span>
                      <span class="s_key" style="margin-left:10px;">标的数: </span><span class="s1">{{item.goods_num}}</span>
                      <span class="s_key" style="margin-left:10px;">拍卖地点: </span><span class="s1">{{item.auctions_address}}</span>
                    </mu-col>
                    <mu-col span="12">
                      <span class="s_key">拍卖会开始时间: </span><span class="s1">{{item.auctions_starttime_a}}</span>
                      <span class="s_key" style="margin-left:10px;">主办单位: </span><span class="s1">{{item.auctionCompanyName}}</span>
                    </mu-col>
                  </mu-row>
                </div>

                <div style="border: 0px solid #000;vertical-align: center;line-height: 25px;margin: 0;padding: 0">
                  <van-button type="primary" size="mini" @click="show_auction_note(index)">拍卖公告</van-button>

                  <template v-if="item.auctions_isover == 0">
                    <van-button type="primary" size="mini" @click="show_dialog_input_visitor(index)">游客观看</van-button>
                  </template>
                  <template v-if="item.auctions_isover == 1">
                    <van-button type="primary" size="mini" @click="show_auction_result(index)">拍卖结果</van-button>
                  </template>
                </div>
              </mu-expansion-panel>
            </mu-paper>

            <template v-if="index == search_total_count - 1">
              <mu-paper class="demo-paper" :z-depth="0" style="border: 0px solid #0f0; width:100%;padding: 0;margin:0;">
                <mu-container style="border: 0px solid #f00;vertical-align: center;text-align: center;">
                  <mu-row gutter>
                    <mu-col span="12">
                      <span style="font-size: 8px;font-weight:bold; color: rgba(125,150,125,.8)" >------------ 已 经 到 底 -------------</span>
                    </mu-col>
                  </mu-row>
                </mu-container>
              </mu-paper>
            </template>
          </template>
        </mu-list>
      </mu-load-more>

    <mu-container width="100%" v-show="openSearchDialog" height="100%">
      <mu-appbar title="拍卖会搜索">
        <mu-button slot="left" icon @click="openSearchDialog = false">
          <mu-icon value="close"></mu-icon>
        </mu-button>
        <mu-button slot="right" flat @click="openSearchDialog = false">
          取消
        </mu-button>
      </mu-appbar>
      <div style="padding: 24px;">
        <mu-form ref="new_searchMap" :model="new_searchMap" class="mu-demo-form" label-position="left" label-width="150">
          <mu-form-item prop="auctions_name" label="拍卖会名字">
            <mu-text-field v-model="new_searchMap.auctions_name"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="auctionCompanyName" label="主办单位">
            <mu-text-field v-model="new_searchMap.auctionCompanyName"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="auctions_starttime_start" label="拍卖会开始时间起">
            <mu-date-input type="date" width="60%" actions v-model="new_searchMap.auctions_starttime_start"  container="bottomSheet" full-width label-float :action-icon="true ? 'delete' : 'delete'" :action-click="() => (new_searchMap.auctions_starttime_start = '')"></mu-date-input>
          </mu-form-item>
          <mu-form-item prop="auctions_starttime_end" label="拍卖会开始时间止">
            <mu-date-input type="date" actions v-model="new_searchMap.auctions_starttime_end"  container="bottomSheet" full-width label-float
                                 :action-icon="true ? 'delete' : 'delete'" :action-click="() => (new_searchMap.auctions_starttime_end = '')"/>
          </mu-form-item>
        </mu-form>

        <mu-button color="primary" full-width @click="submit_search">搜索</mu-button>

      </div>
    </mu-container>



    <van-dialog v-model="show_dialog_input_visitor_bool" style="width:300px;" title="游客观看拍卖会" show-cancel-button @confirm="show_dialog_input_visitor_confirm" >
      <div style="padding: 5px;">
        <mu-form ref="show_dialog_input_visitorMap" :model="show_dialog_input_visitorMap" class="mu-demo-form" label-position="left" label-width="60">
          <div style="font-size:10px;">{{show_dialog_input_visitorMap.auction_name}}</div>
          <mu-form-item prop="visitor_tel" label="手机号">
            <mu-text-field v-model="show_dialog_input_visitorMap.visitor_tel"></mu-text-field>
          </mu-form-item>
          <mu-form-item prop="visitor_sign" label="观看码">
            <mu-text-field v-model="show_dialog_input_visitorMap.visitor_sign"></mu-text-field>
          </mu-form-item>
        </mu-form>
      </div>
    </van-dialog>
</div>

</template>

<script>
  import axios from 'axios'
  import Qs from 'qs'
  import Toast from 'muse-ui-toast';
  import Mj from '@/components/lib/Mj.js'
  import { Dialog } from 'vant';

  export default {
    created: function () {
      let _this = this;
      let loading = _this.$loading();
      let parms = {};
      Object.assign(parms, this.searchMap, {begin: 0});
      this.$progress.start();

      function init() {
        var p = new Promise(function (resolve, reject) {
          axios.post('/front/auction_list.mvc', Qs.stringify(parms))
            .then(function (response) {
             // console.log("select.mvc response = "+JSON.stringify(response));
              if (response.data.status == "0") {
                Toast.error('没有数据！');
              }
              if (response.data.status == "2") {
                Toast.error('查询异常！');
              }
              if (response.data.status == "3") {
                Dialog.alert({
                  title: '请重新登录',
                  message: ''
                }).then(() => {
                  _this.$router.replace("/Login");
                });
              }
              if (response.data.status == "1") {
                _this.in_list = response.data.data;
                _this.total_count = response.data.total_count;
                _this.search_total_count = response.data.search_total_count;
                _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
                //console.log("_this.$refs.lm.loadedAll="+ _this.$refs.lm.loadedAll);
                Toast.success('OK！');
              }
              resolve();
            })
            .catch(function (error) {
              console.log(error);
            })
        });
        return p;
      }

      Promise
        .all([
          init()
        ])
        .then(function (results) {
          _this.$progress.done();
          loading.close();
        });

      //init 表单日期
      let date = new Date();
      let month = (date.getMonth() + 1).toString().padStart(2, '0');
      let strDate = date.getDate().toString().padStart(2, '0');
      //时间格式yyyy-MM-dd HH:MM:SS
      //this.form.in_stock_date = `${date.getFullYear()}-${month}-${strDate}`;

    },
    data() {
      return {
        show_dialog_input_visitor_bool:false,
        show_dialog_input_visitorMap: {
          auction_name : '',
          auction_id: '',
          company_id: '',
          visitor_tel: '',
          visitor_sign: ''
        },

        username: this.STORE.login.name,

        in_list: {},
        search_total_count: 0,
        total_count: 0,
        refreshing: false,
        loading: false,
        text: 'List',
        //loaded-all : false,

        openSearchDialog: false,
        searchMap: {
          auctions_name: '',
          auctionCompanyName: '',

          auctions_starttime_start: '',
          auctions_starttime_end: '',
        },
        new_searchMap: {
          auctions_name: '',
          auctionCompanyName: '',

          auctions_starttime_start: '',
          auctions_starttime_end: '',
        }
      }
    },
    computed: {

      search_auctions_starttime_start_computed: function () {
        let dt = this.searchMap.auctions_starttime_start;
        let y = dt.getFullYear();
        let m = dt.getMonth() + 1;
        let d = dt.getDate();
        if(y == new Date().getFullYear()){
          return `${m}-${d}`;
        }else{
          return `${y}-${m}-${d}`;
        }
      },

      search_auctions_starttime_end_computed: function () {
        let dt = this.searchMap.auctions_starttime_end;
        let y = dt.getFullYear();
        let m = dt.getMonth() + 1;
        let d = dt.getDate();

        if(y == new Date().getFullYear()){
          return `${m}-${d}`;
        }else{
          return `${y}-${m}-${d}`;
        }
      }
    },
    methods: {
      toHome() {
        window.open("http://123jc.com", "_blank");
      },
      search_click() {
        Object.assign(this.new_searchMap, this.searchMap);
        //this.new_searchMap = this.searchMap;
        this.openSearchDialog = true;
      },
      serach_key_delete(t) {
        if (t == 'auctions_name'){
          this.searchMap.auctions_name = "";
          this.new_searchMap.auctions_name = "";
        }
        if (t == 'auctionCompanyName'){
          this.searchMap.auctionCompanyName = "";
          this.new_searchMap.auctionCompanyName = "";
        }

        if (t == 'auctions_starttime'){
          this.searchMap.auctions_starttime_start = "";
          this.new_searchMap.auctions_starttime_start = "";
          this.searchMap.auctions_starttime_end = "";
          this.new_searchMap.auctions_starttime_end = "";
        }
        this.submit_search();
      },
      show_dialog_input_visitor(index) {

        let item = this.in_list[index];
        this.show_dialog_input_visitorMap.auction_name = item.auctions_name;
        this.show_dialog_input_visitorMap.auction_id = item.auctions_id;
        this.show_dialog_input_visitorMap.company_id = item.auctionCompanyId;
        this.show_dialog_input_visitorMap.visitor_tel = "";
        this.show_dialog_input_visitorMap.visitor_sign = "";

        this.show_dialog_input_visitor_bool = true;
      },
      show_dialog_input_visitor_confirm() {

        let url ="visitor/auction.mvc" +
          "?a="+ this.show_dialog_input_visitorMap.auction_id +
          "&c="+ this.show_dialog_input_visitorMap.company_id +
          "&s="+ this.show_dialog_input_visitorMap.visitor_sign +
          "&t=" + this.show_dialog_input_visitorMap.visitor_tel;
       // url = "http://192.168.123.250/" + url;
        window.open(url, "_blank");
      },

      show_auction_note(index) {
        let item = this.in_list[index];
        let url ="front/auctionnote.mvc" +
          "?aid="+ item.auctions_id ;

       // url = "http://192.168.123.250/" + url;
        window.open(url, "_blank");
      },

      show_auction_result(index) {
        let item = this.in_list[index];
        let url ="front/auctionresult.mvc" +
          "?aid="+ item.auctions_id ;

       // url = "http://192.168.123.250/" + url;
        window.open(url, "_blank");
      },
      refresh() {
        this.refreshing = true;
        let parms = {};
        let _this = this;
        Object.assign(parms, this.searchMap, {begin: 0});
        axios.post('/front/auction_list.mvc', Qs.stringify(parms))
          .then(function (response) {
            _this.refreshing = false;
            if (response.data.status == "0") {
              Toast.error('没有数据！');
            }
            if (response.data.status == "2") {
              Toast.error('查询异常！');
            }
            if (response.data.status == "3") {
              Dialog.alert({
                title: '请重新登录',
                message: ''
              }).then(() => {
                _this.$router.replace("/Login");
              });
            }
            if (response.data.status == "1") {
              _this.in_list = response.data.data;
              _this.total_count = response.data.total_count;
              _this.search_total_count = response.data.search_total_count;
              _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
              Toast.success('刷新完成！');
            }
          })
          .catch(function (error) {
            console.log(error);
          });
      },
      load() {
        let _this = this;
        _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
        if (_this.$refs.lm.loadedAll) {
          this.loading = true;
          let parms = {};
          Object.assign(parms, this.searchMap, {begin: _this.in_list.length});
          axios.post('/front/auction_list.mvc', Qs.stringify(parms))
            .then(function (response) {
              _this.loading = false;
              _this.refreshing = false;
              if (response.data.status == "0") {
                Toast.error('没有数据！');
              }
              if (response.data.status == "2") {
                Toast.error('查询异常！');
              }
              if (response.data.status == "3") {
                Dialog.alert({
                  title: '请重新登录',
                  message: ''
                }).then(() => {
                  _this.$router.replace("/Login");
                });
              }
              if (response.data.status == "1") {
                _this.text = _this.text === 'List' ? 'Menu' : 'List';
                _this.in_list = _this.in_list.concat(response.data.data);
                _this.total_count = response.data.total_count;
                _this.search_total_count = response.data.search_total_count;
                _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
                //console.error("insert ok-------" + _this.$refs.lm.loadedAll);
                Toast.success('读取更多完成！');
              }
            })
            .catch(function (error) {
              this.loading = false;
              console.log(error);
            });
        }
      },
      submit_search() {
        let _this = this;
        let loading = _this.$loading();
        this.$progress.start();
        function init() {
          var p = new Promise(function (resolve, reject) {
            Object.assign(_this.searchMap, _this.new_searchMap);
            //this.new_searchMap = this.searchMap;
            _this.openSearchDialog = false;
            let parms = {};
            Object.assign(parms, _this.searchMap, {begin: 0});
            axios.post('/front/auction_list.mvc', Qs.stringify(parms))
              .then(function (response) {
                // console.log("select.mvc response = "+JSON.stringify(response));
                if (response.data.status == "0") {
                  Toast.error('没有数据！');
                }
                if (response.data.status == "2") {
                  Toast.error('查询异常！');
                }
                if (response.data.status == "3") {
                  Dialog.alert({
                    title: '请重新登录',
                    message: ''
                  }).then(() => {
                    _this.$router.replace("/Login");
                  });
                }
                if (response.data.status == "1") {
                  _this.in_list = response.data.data;
                  _this.total_count = response.data.total_count;
                  _this.search_total_count = response.data.search_total_count;
                  _this.$refs.lm.loadedAll = _this.search_total_count > _this.in_list.length;
                  Toast.success('OK！');
                }
                resolve();
              })
              .catch(function (error) {
                console.log(error);
              });
          });
          return p;
        }
        Promise
          .all([
            init()
          ])
          .then(function (results) {
            _this.$progress.done();
            loading.close();
          });
      },

      clear() {
        this.$refs.form.clear();
        this.form = {
          in_stock_type: '',
          in_stock_model: '',
          in_stock_production_date: '',
          in_stock_quantity: '',
          in_stock_date: '',
          in_stock_from: '',
          in_stock_unit_price: '',
          in_stock_total_price: ''
        };
      }
    }
  };
</script>
<style>
  .mu-paper .mu-expansion-panel-header {
    padding: 0 10px;
  }
  .mu-paper .mu-icon-button {
    width: 36px;
    height: 36px;
  }
  .mu-paper  .mu-expansion-panel-content {
    padding: 0 10px 10px;
    line-height: 1.4;
  }
</style>
<style scoped>
  .div1 {
    display: flex;
    min-height: 100vh;
    flex-direction: column;
  }

  .mu-container {
    min-width: 250px;
    width: 300px;
  }

  .demo-loadmore-wrap {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .demo-loadmore-content {
    width: 100%;
    flex: 1;
    overflow: auto;
    -webkit-overflow-scrolling: touch;
  }

  .s1 {
    font-size: 12px;
    font-weight: bolder;
  }

  .s_key {
    font-size: 8px;
  }

  .auctions_isover{
    color: rgba(0, 0, 0, .4)
  }

  .auctions_today{
    color: rgba(255, 0, 0, .5)
  }

</style>



// WEBPACK FOOTER //
// src/components/front/Front.vue